// @flow

import type { ApprovableChangeState } from "./types";

export const initialState: ApprovableChangeState = {
  schemas: {
    block: null,
    defer: null,
    approve: null,
  },
  modals: {
    showBlockModal: false,
    showDeferModal: false,
    showApproveModal: false,
  },
};

export default initialState;
